module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c78a936bf640a0c11b21af1330d15df.png";